import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const VideoSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    email: "",
    objetivo: "",
  });

  const [backgroundImage, setBackgroundImage] = useState(
    "https://ernestomora.com/wp-content/uploads/2025/01/Banner-pagina-emora-1024x576.jpg"
  );

  const navigate = useNavigate();
  const goToBlog = () => navigate("/blogernesto");
  const irANuevaPantalla = () => navigate("/Biografia");

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const handleOverlayClick = () => setShowOverlay(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Información enviada correctamente.");
    setShowForm(false);
  };

  const closeForm = () => setShowForm(false);

  useEffect(() => {
    const updateBackground = () => {
      if (window.innerWidth < 770) {
        setBackgroundImage(
          "https://celebratufiesta.com.co/wp-content/uploads/2025/06/Banner-pagina-emora.png"
        );
      } else {
        setBackgroundImage(
          "https://celebratufiesta.com.co/wp-content/uploads/2025/06/Banner-pagina-emora-2.png"
        );
      }
    };

    updateBackground();
    window.addEventListener("resize", updateBackground);
    return () => window.removeEventListener("resize", updateBackground);
  }, []);

  return (
    <div
      className="relative flex flex-col items-center justify-center min-h-[75vh] bg-cover bg-center text-white"
      style={{ backgroundImage: `url('${backgroundImage}')` }}
    >
    {/* Botones superiores */}
    <div className="absolute top-4 left-0 right-0 px-4 flex justify-between items-center z-50">
      <div className="flex gap-1 sm:gap-2">
        <button
          onClick={goToBlog}
          className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-1.5 px-3 sm:py-2 sm:px-4 rounded-full text-xs sm:text-sm shadow-md"
        >
          BLOG
        </button>
        <button
          onClick={irANuevaPantalla}
          className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-1.5 px-3 sm:py-2 sm:px-4 rounded-full text-xs sm:text-sm shadow-md"
        >
          BIOGRAFÍA
        </button>
      </div>
      <button
        onClick={() => setShowForm(true)}
        className="bg-red-600 hover:bg-red-700 text-white font-bold py-1.5 px-3 sm:py-2 sm:px-4 rounded-full text-xs sm:text-sm shadow-md"
      >
        Contacta A Ernesto
      </button>
    </div>


      {/* Firma solo visible en pantallas grandes */}
      <div className="mb-12 text-center mt-20 hidden lg:block lg:mt-28">
        <img
          src="https://celebratufiesta.com.co/wp-content/uploads/2025/01/firma.png"
          alt="Ernesto Logo"
          className="mx-auto h-48 w-auto"
        />
      </div>


      {/* Botón de video (solo en pantallas md y más) */}
      <div className="flex flex-col items-center mt-32 mb-12">
        <button
          onClick={openModal}
          className="hidden md:flex bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] text-black w-24 h-24 items-center justify-center rounded-full mb-8 shadow-lg hover:scale-105 transition-transform"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M14.752 11.168l-3.197 1.684A1 1 0 0110 11.017V8.983a1 1 0 011.555-.832l3.197 1.683a1 1 0 010 1.666z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
            />
          </svg>
        </button>

        {/* Texto para pantallas grandes y medianas */}
        <div className="hidden md:block text-center bg-black bg-opacity-50 p-4 rounded-lg max-w-xl mt-8">
          <p className="text-lg md:text-xl lg:text-2xl uppercase text-white">
            ÚNETE A LA TRIBU DE CONSULTORES
          </p>
          <p className="text-lg md:text-xl lg:text-2xl italic font-semibold text-white">
            Que está transformando la seguridad y salud <br /> en el Trabajo en toda LATAM a través de la IA.
          </p>
        </div>
      </div>

      {/* Texto final para pantallas pequeñas */}
      <div className="block md:hidden absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-50 p-4 rounded-lg max-w-xs text-center">
        <p className="text-sm uppercase text-white">
          ÚNETE A LA TRIBU DE CONSULTORES
        </p>
        <p className="text-sm italic font-semibold text-white">
          Que está transformando la seguridad y salud <br /> en el Trabajo en toda LATAM a través de la IA.
        </p>
      </div>

      {/* Modal video */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
          <div className="bg-black relative max-w-4xl w-full">
            <div className="relative w-full h-0" style={{ paddingBottom: "56.25%" }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/OHlUknpkGnQ?autoplay=1&mute=1"
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            {showOverlay && (
              <div
                onClick={handleOverlayClick}
                className="absolute inset-0 bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] bg-opacity-90 flex flex-col items-center justify-center cursor-pointer"
              >
                <p className="text-black font-bold text-xl mb-2">ACTIVA EL SONIDO</p>
                <p className="text-black text-lg">TOCANDO AQUÍ</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-12 w-12 mt-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            )}

            <button
              onClick={closeModal}
              className="absolute top-2 right-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-full p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* Formulario */}
      {showForm && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={closeForm}
        >
          <div
            className="bg-white p-6 bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] text-black font-bold rounded-lg w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-bold mb-4">Formulario de Contacto</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700">Nombre*</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Teléfono*</label>
                <input
                  type="text"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">E-mail*</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">
                  ¿Con qué objetivo quieres contratar a Ernesto?*
                </label>
                <textarea
                  name="objetivo"
                  value={formData.objetivo}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2"
                ></textarea>
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={closeForm}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded mr-2"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-600 text-white rounded"
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoSection;
